const agentTypes = {
    SHIPMENT_INTELLIGENCE: 'SHIPMENT_INTELLIGENCE',
};

module.exports = {
    agentTypes,
};